import { render, staticRenderFns } from "./DetailsPanel.vue?vue&type=template&id=2d262c79&scoped=true"
import script from "./DetailsPanel.vue?vue&type=script&lang=js"
export * from "./DetailsPanel.vue?vue&type=script&lang=js"
import style0 from "./DetailsPanel.vue?vue&type=style&index=0&id=2d262c79&prod&scoped=true&lang=scss"
import style1 from "./DetailsPanel.vue?vue&type=style&index=1&id=2d262c79&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d262c79",
  null
  
)

export default component.exports